import { render, staticRenderFns } from "./wxshenhePre.vue?vue&type=template&id=5d4ca1a4&scoped=true"
import script from "./wxshenhePre.vue?vue&type=script&lang=js"
export * from "./wxshenhePre.vue?vue&type=script&lang=js"
import style0 from "./wxshenhePre.vue?vue&type=style&index=0&id=5d4ca1a4&prod&scoped=true&lang=css"
import style1 from "./wxshenhePre.vue?vue&type=style&index=1&id=5d4ca1a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ca1a4",
  null
  
)

export default component.exports